import React from 'react';
import './Roadmap.css';

// The project's analysis workflow (shared across every workflow screen).
// `activeStage` is the 0-based index of the current screen's stage.
export const WORKFLOW_STAGES = [
  'פרטי פרויקט',
  'זיהוי ואיסוף נתונים',
  'ניתוח מצב סטטוטורי',
  // Chunk 04 folds the former plans / building-file / existing-summary /
  // existing-drawings stages into ONE existing-condition stage driven by the six
  // inference routes, and the back half follows the chunk-04 visual.
  'ניתוח מצב קיים',
  'מצב מוצע',
  'חישוב זכויות',
  'התאמות נדרשות',
  'דוח מסכם',
  'ייצוא מסמכים',
];

// The furthest stage a project actually reached, derived from the snapshot each
// stage persists. Every screen computed this inline and each copy stopped at the
// statutory stage, so a project that had reached the existing-condition stage
// could never be reopened there — one place to get it right instead of four.
export function reachedStageFor(project) {
  if (!project) return 0;
  if (project.existing) return 3;
  if (project.statutory) return 2;
  if (project.identification) return 1;
  return 0;
}

// onStageClick(index) fires when a navigable stage is clicked. Navigable = any
// stage the user has already reached (backward to completed stages OR forward to
// stages they previously got to), but not the active one. `reachedStage` is the
// furthest stage index reached (defaults to the active stage = no forward nav).
export default function Roadmap({ activeStage = 0, reachedStage = activeStage, onStageClick }) {
  const furthest = Math.max(activeStage, reachedStage);
  return (
    <section className="rm-card">
      <header className="rm-head">
        <i className="fi fi-rr-list-check" />
        <h3>שלבי העבודה</h3>
      </header>
      <ol className="rm-list">
        {WORKFLOW_STAGES.map((label, i) => {
          const state = i < activeStage ? 'done' : i === activeStage ? 'active' : 'todo';
          const clickable = i !== activeStage && i <= furthest && Boolean(onStageClick);
          const inner = (
            <>
              <span className="rm-no">{state === 'done' ? <i className="fi fi-rr-check" /> : i + 1}</span>
              <span className="rm-label">{label}</span>
            </>
          );
          return (
            <li key={label} className={`rm-stage is-${state} ${clickable ? 'is-clickable' : ''}`}>
              {clickable
                ? <button type="button" className="rm-btn" onClick={() => onStageClick(i)} title="חזרה לשלב זה">{inner}</button>
                : <div className="rm-btn">{inner}</div>}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
